module.exports = __webpack_public_path__ + "images/category_lp/common/Hikakaku@2x_9941822b40e2befe5290bd1b33081aa3.png";